import type {DyEvent} from '@dynamic-yield/scripts/components/dynamic-yield/dy-event-types';

declare global {
    interface Window {
        setDyCategoryPath?: (categoryPath?: string[]) => void;
        sendDyEvent?: (event: DyEvent) => void;
    }
}

export function updateDyCategoryRecommendationContext(categoryPath?: string[]): void {
    window.setDyCategoryPath?.(categoryPath);
}

export function sendDyIntegrationEvent(event: DyEvent): void {
    window.sendDyEvent?.(event);
}
